import { render } from "./TableEmpty.vue?vue&type=template&id=3fd4e716&ts=true"
import script from "./TableEmpty.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableEmpty.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fd4e716"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fd4e716', __exports__)) {
    api.reload('3fd4e716', __exports__)
  }
  
  module.hot.accept("./TableEmpty.vue?vue&type=template&id=3fd4e716&ts=true", () => {
    api.rerender('3fd4e716', render)
  })

}


export default __exports__